/* <co-faq-page> — FAQ category tabs. Clicking a tab shows that category and hides the others; the
   URL hash reflects the active tab and is honoured on load (and on hashchange / back-forward).
   Progressive enhancement: until JS adds `is-ready`, all categories render (no-JS fallback).
   Editor-resilient (custom element; deferred so children exist at connect; AbortController teardown). */
(function () {
  if (customElements.get('co-faq-page')) return;

  class CoFaqPage extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._ac = new AbortController();
      var sig = this._ac.signal;
      var self = this;

      this.links = Array.prototype.slice.call(this.querySelectorAll('.co-faq__nav-link'));
      this.sections = Array.prototype.slice.call(this.querySelectorAll('.co-faq__category'));
      if (!this.links.length || !this.sections.length) return;

      this.classList.add('is-ready'); // CSS now shows only the active category (tab mode)

      this.links.forEach(function (link) {
        link.addEventListener('click', function (e) {
          var id = (link.getAttribute('href') || '').replace(/^#/, '');
          if (!id) return;
          e.preventDefault();
          self._activate(id, true);
        }, { signal: sig });
      });

      // Honour the hash on load (deep-link to a tab), else the first tab.
      var initial = (window.location.hash || '').replace(/^#/, '');
      if (!initial || !this._hasSection(initial)) initial = this.sections[0].id;
      this._activate(initial, false);

      window.addEventListener('hashchange', function () {
        var id = (window.location.hash || '').replace(/^#/, '');
        if (self._hasSection(id)) self._activate(id, false);
      }, { signal: sig });
    }

    disconnectedCallback() {
      if (this._ac) this._ac.abort();
      this._ready = false;
    }

    _hasSection(id) {
      return this.sections.some(function (s) { return s.id === id; });
    }

    _activate(id, updateHash) {
      var target = null;
      this.links.forEach(function (link) {
        link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
      });
      this.sections.forEach(function (s) {
        var on = s.id === id;
        s.classList.toggle('is-active', on);
        if (on) {
          target = s;
          // Reveal entry animations that may have been display:none when co-anim first ran.
          var hidden = s.querySelectorAll('[data-co-anim]:not(.co-anim-in)');
          for (var i = 0; i < hidden.length; i++) hidden[i].classList.add('co-anim-in');
        }
      });
      if (updateHash && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + id);
      }
      // Swapping a long category for a short one can shrink the page beneath the current
      // scroll position, stranding the viewport on the footer. After a user-initiated
      // switch, if the new category's top ended up above the viewport (or behind the
      // sticky header / mobile tab strip), jump back to it. scroll-margin-top in the CSS
      // sets the exact landing offset per breakpoint; on-load/hash activations keep the
      // browser's native anchor behavior instead.
      if (updateHash && target) {
        var margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
        if (target.getBoundingClientRect().top < margin - 4) {
          target.scrollIntoView({ block: 'start' });
        }
      }
    }
  }

  customElements.define('co-faq-page', CoFaqPage);
})();
